import { PortalContext } from "App";
import { useCallback, useContext, useMemo } from "react";

/**
 * hook to simplify access to page state
 *
 * @param {Object} props
 * @param {String} props.pagePath The page path of the caller
 * @returns
 */
const usePageState = ({ pagePath }) => {
  if (!pagePath) console.warn("pagePath is required");

  const stateContext = useContext(PortalContext);
  const { detailPageState, setDetailPageState } = stateContext;

  const sessionState = JSON.parse(sessionStorage.getItem("state"));

  // note: upon refresh, detailPageState will not be immediately available yet, so we need to fallback to the session state (which is identical, but with a different reference)
  // this however, triggers multiple re-renders, which is not ideal
  const pageState = useMemo(
    () => detailPageState?.[pagePath] || sessionState?.[pagePath] || {},
    [detailPageState, sessionState, pagePath],
  );

  const setPageState = useCallback(
    (newPageState) => {
      switch (typeof newPageState) {
        case "function": {
          setDetailPageState((prevState) => ({
            ...prevState,
            [pagePath]: newPageState(prevState?.[pagePath]),
          }));
          break;
        }
        default: {
          setDetailPageState((prevState) => ({
            ...prevState,
            [pagePath]: newPageState,
          }));
          break;
        }
      }
    },
    [setDetailPageState],
  );

  return { pageState, setPageState };
};

export default usePageState;
